import { useQuery } from '@tanstack/react-query';
import { countryRequest } from 'api/CountryRequest';
import { ApiResponseGetCitiesByCountryId } from 'api/types/country';
import { queryKeys } from '../../constants/queryKeys';

function useGetCityByCountryId(
  queryOptions: {
    id: string;
    offset: number;
    limit: number;
    searchText?: string;
  },
  enabled?: boolean
) {
  const QUERY_KEY = [queryKeys.cities, queryOptions];
  return useQuery<ApiResponseGetCitiesByCountryId[], Error>({
    queryKey: QUERY_KEY,
    queryFn: () => countryRequest.getCitiesByCountryId(queryOptions),
    enabled,
  });
}
export default useGetCityByCountryId;
